export const BASEURL = "https://imsoft.uz/api/";
